import { useTranslation } from "react-i18next";
import { PaymentSummaryProps } from "../types";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { useRequestOtpMutation } from "@/stores/queries/payments.query";
import { toast } from "@/utils/toast.utils";
import { convertToMonetaryAmount } from "@/utils/numbers.utils";
import { ContentCard } from "@/components/ui/data-display";
import { PaymentDetailsSection } from "./PaymentDetailsSection";
import { PaymentBreakdownSection } from "./PaymentBreakdownSection";
import { RewardsSection } from "./RewardsSection";
import { ButtonWithLoading } from "@/components/core/Form/ButtonWithLoading";

export function PaymentSummary({
  data,
  requestAmount,
  requestTip,
  currency,
  onBack,
  onRequestOtp,
}: PaymentSummaryProps) {
  const { t } = useTranslation();
  const { mutate: requestOtp, isPending: isLoading } = useRequestOtpMutation();

  const activeCurrency = data.currency || currency;

  const handleConfirm = () => {
    requestOtp(
      {
        memberId: data.memberId,
        locationId: data.locationId,
        amountToPay: convertToMonetaryAmount(requestAmount),
        tipAmount: convertToMonetaryAmount(requestTip),
        note: data.note || "",
      },
      {
        onSuccess: (response) => {
          toast.success(t("payment.otpRequested"));
          if (onRequestOtp) {
            onRequestOtp(response.otpPaymentId);
          }
        },
        onError: () => {
          toast.error(t("payment.otpRequestFailed"));
        },
      }
    );
  };

  return (
    <ContentCard
      title={t("payment.summary")}
      description={t("payment.summaryDescription")}
    >
      <PaymentDetailsSection
        amount={requestAmount}
        currency={activeCurrency}
        // tip={requestTip}
      />

      <Separator />

      <PaymentBreakdownSection
        mezzaCreditsAmount={data.mezzaCreditsAmount}
        paymentMethodAmount={data.paymentMethodAmount}
        paymentMethodLast4={data.paymentMethodLast4}
        currency={activeCurrency}
        // tipAmount={requestTip}
      />

      <RewardsSection creditBackEarned={data.creditBackEarned} currency={activeCurrency} isSuccess={false} />

      <div className="flex flex-col space-y-3">
        <ButtonWithLoading
          onClick={handleConfirm}
          disabled={isLoading}
          className="w-full"
          isLoading={isLoading}
        >
          {t("payment.confirm")}
        </ButtonWithLoading>

        <Button onClick={onBack} variant="outline" className="w-full">
          {t("payment.backToForm")}
        </Button>
      </div>
    </ContentCard>
  );
}
